import { cloneDeep } from 'lodash';
import { localizeDate } from '@/utils/date';
export default {
  name: 'CoreVirtualDeviceSmartGroupsChartsAlarmLogsByDayNewVersusResolved',
  props: {
    alarmLogs: {
      type: Array,
      required: true
    },
    timeRange: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        }
      },
      typeColorMap: {
        new: '245, 20, 75',
        resolved: '65, 217, 39'
      }
    };
  },
  computed: {
    dateCodeType() {
      const from = new Date(this.timeRange.from * 1000);
      const to = new Date(this.timeRange.to * 1000);
      const nextYear = new Date(from);
      nextYear.setFullYear(nextYear.getFullYear() + 1);
      if (nextYear < to) {
        return 'year';
      }
      const nextMonth = new Date(from);
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      if (nextMonth < to) {
        return 'month';
      }
      return 'day';
    },
    dateCodes() {
      const from = new Date(this.timeRange.from * 1000);
      const to = new Date(this.timeRange.to * 1000);
      switch (this.dateCodeType) {
        case 'year':
          return this.getYearCodes(from, to);
        case 'month':
          return this.getMonthCodes(from, to);
        case 'day':
          return this.getDayCodes(from, to);
        default:
          throw new Error('Unknown date code type');
      }
    },
    labels() {
      if (this.dateCodeType === 'year') {
        return this.dateCodes;
      }
      return this.dateCodes.map(dateCode => {
        const [year, month, day] = dateCode.split('-');
        const date = new Date(year, month - 1, day || 1);
        return localizeDate(date, this, {
          time: false,
          date: {
            withDay: this.dateCodeType === 'day',
            withMonth: true
          }
        });
      });
    },
    datasets() {
      const datasetBaseConfig = {
        label: '',
        data: [],
        borderColor: '',
        fill: false
      };
      const newLogsDataSet = {
        ...cloneDeep(datasetBaseConfig),
        label: this.$i18n_t('AlarmLogs.smartGroup.charts.byDayNewVersusResolved.new'),
        borderColor: `rgb(${this.typeColorMap.new})`,
        backgroundColor: `rgba(${this.typeColorMap.new}, 0.2)`
      };
      const resolvedLogsDataSet = {
        ...cloneDeep(datasetBaseConfig),
        label: this.$i18n_t('AlarmLogs.smartGroup.charts.byDayNewVersusResolved.resolved'),
        borderColor: `rgb(${this.typeColorMap.resolved})`,
        backgroundColor: `rgba(${this.typeColorMap.resolved}, 0.2)`
      };
      this.dateCodes.forEach((_, index) => {
        newLogsDataSet.data[index] = 0;
        resolvedLogsDataSet.data[index] = 0;
      });
      const getDateCodeIndexOfLog = logToCheck => {
        return this.dateCodes.findIndex(dateCode => {
          return logToCheck.timestamp.startsWith(dateCode);
        });
      };
      this.alarmLogs.forEach(log => {
        const indexOfMatchingDateCode = getDateCodeIndexOfLog(log);
        if (indexOfMatchingDateCode === -1) {
          return;
        }
        newLogsDataSet.data[indexOfMatchingDateCode] += 1;
        if (log.isResolved) {
          const resolvingChild = log.children.find(child => child.logType === 'RESOLVE');
          if (!resolvingChild) {
            return;
          }
          const indexOfMatchingDateCodeOfResolvingChild = getDateCodeIndexOfLog(resolvingChild);
          resolvedLogsDataSet.data[indexOfMatchingDateCodeOfResolvingChild] += 1;
        }
      });
      return [newLogsDataSet, resolvedLogsDataSet];
    }
  },
  methods: {
    getDayCodes(from, to) {
      const dayCodes = [];
      const workingDate = new Date(from);
      while (workingDate <= to) {
        const day = workingDate.getDate().toString().padStart(2, '0');
        const month = (workingDate.getMonth() + 1).toString().padStart(2, '0');
        const year = workingDate.getFullYear();
        const dayCode = `${year}-${month}-${day}`;
        if (!dayCodes.includes(dayCode)) {
          dayCodes.push(dayCode);
        }
        workingDate.setDate(workingDate.getDate() + 1);
      }
      return dayCodes;
    },
    getMonthCodes(from, to) {
      const monthCodes = [];
      const workingDate = new Date(from);
      while (workingDate <= to) {
        const month = workingDate.getMonth() + 1;
        const year = workingDate.getFullYear();
        const monthCode = `${year}-${month.toString().padStart(2, '0')}`;
        if (!monthCodes.includes(monthCode)) {
          monthCodes.push(monthCode);
        }
        workingDate.setMonth(workingDate.getMonth() + 1);
      }
      return monthCodes;
    },
    getYearCodes(from, to) {
      const yearCodes = [];
      const workingDate = new Date(from);
      while (workingDate <= to) {
        const year = workingDate.getFullYear();
        if (!yearCodes.includes(year)) {
          yearCodes.push(String(year));
        }
        workingDate.setFullYear(workingDate.getFullYear() + 1);
      }
      return yearCodes;
    }
  }
};